module.exports = __webpack_public_path__ + "static/img/logo-full-backdrop.8e9de4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-full-backdrop.png
// module id = wgYQ
// module chunks = 0